import Immutable from 'seamless-immutable';
import _ from 'lodash';
import {
  getForm,
  createValidateObject,
  storeRecoveryFieldValues,
  storeSetFieldValue,
  storeSetFieldsErrors,
  createField
} from '../../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../../utils/reducerHalpers/validateTypes';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../utils/reducerHalpers/requestState';

export const INIT_STATE = 'INIT_STATE';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
export const SEND_FORM = 'SEND_FORM';
export const RECOVERY_FIELDS = 'RECOVERY_FIELDS';
export const SET_ERRORS = 'SET_ERRORS';
export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';

const CHANGE_MESSAGE = 'CHANGE_MESSAGE';

export const CHANGE_FIELD_PASSWORD = 'CHANGE_FIELD_PASSWORD';
export const CHANGE_FIELD_PASSWORD_CONFIRM = 'CHANGE_FIELD_PASSWORD_CONFIRM';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      fields: {
        ...createField({
          field: 'password',
          title: 'Новый пароль',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        }),
        ...createField({
          field: 'password_confirm',
          title: 'Новый пароль еще раз',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        })
      },
      errors: [],
      message: ''
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, RECOVERY_FIELDS):
        return storeRecoveryFieldValues(state, action.payload);
      case createActionName(name, SEND_FORM):
        return setRequestStateInProgress(state);
      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return state;

      case createActionName(name, CHANGE_MESSAGE):
        return state.merge({
          message: action.payload.message
        });

      case createActionName(name, CHANGE_FIELD_PASSWORD): {
        return storeSetFieldValue(state, 'password', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_PASSWORD_CONFIRM): {
        return storeSetFieldValue(state, 'password_confirm', action.payload);
      }

      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS
export const initState = reducerName => ({
  type: createActionName(reducerName, INIT_STATE)
});
export const requestFinished = (reducerName, codeResponse, hasSuccess) => ({
  type: createActionName(reducerName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const recoveryFields = (reducerName, payload) => ({
  type: createActionName(reducerName, RECOVERY_FIELDS),
  payload
});
export const sendForm = (reducerName, token) => ({
  type: createActionName(reducerName, SEND_FORM),
  payload: { token }
});
export const setErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, SET_ERRORS),
  payload
});
export const clearAllErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, CLEAR_ALL_ERRORS),
  payload
});

export const changeMessage = (reducerName, message) => ({
  type: createActionName(reducerName, CHANGE_MESSAGE),
  payload: { message }
});

// FIELDS
export const changeFieldPassword = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_PASSWORD),
  payload
});
export const changeFieldPasswordConfirm = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_PASSWORD_CONFIRM),
  payload
});

// SELECTORS
export const selectState = (state, reducerName) => getState(state, reducerName);
export const selectRequestState = (state, reducerName) =>
  _.get(getState(state, reducerName), 'requestState');

export const selectFormBody = (state, reducerName) =>
  getForm(getState(state, reducerName));

export const selectAllErrors = (state, reducerName) =>
  _.get(getState(state, reducerName), 'errors');

// Fields
export const selectFieldPassword = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.password');
export const selectFieldPasswordConfirm = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.password_confirm');
export const selectMessage = (state, reducerName) =>
  _.get(getState(state, reducerName), 'message');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/common/reducers/forms/resetPasswordForm.js